import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-inspection-type',
  templateUrl: './inspection-type.component.html',
  styleUrls: ['./inspection-type.component.css']
})
export class InspectionTypeComponent implements OnChanges {
  @Input() InspectionTypeData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  rows : any[];
  cols: any[] = [];
  header: any[] = [];
  clonedData:any[]=[];
  IsEdit:boolean = false;
  InsTypeData : any;
  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnChanges(): void {
    if(this.InspectionTypeData){
        this.cols = [];
        this.rows = [];
        this.header = [];
        this.header = this.InspectionTypeData[0].Headers;
        this.rows = this.InspectionTypeData[0].Rows;
        if(this.header){
          this.header.forEach(element => {
            this.cols.push({'field': this.header.indexOf(element),'header':element })
          });
        }
        if(this.rows){
          this.rows.forEach((element,index) => {
            element.Id = index+1;
          });
        }
    }
  }

  onRowEditInit(data: any) {
    this.clonedData[data.Id] = { ...data };
  }

  onRowEditSave(data: any,ri:number) {
    if (data.Id > 0) {
      if(this.clonedData){
        data.forEach((element,index) => {
          if(index != 0){
            if(data[index] != this.clonedData[data.Id][index]){
              this.rows[this.rows.length - 1][index] = this.rows[this.rows.length - 1][index] - this.clonedData[data.Id][index] + data[index]
            }
          }
        });
        this.clonedData = [];
      }
    }
  }

  onRowEditCancel(data: any, index: number) {
    this.clonedData = [];
  }

  GetInspectionTypeSelectedDetails(rowdata,col){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Inspection Type",
        "Component":rowdata[0] === "Total" || rowdata[0] === "" ? 0 : rowdata[1],
         "Column":col.field,
        "ColumnName":col.header
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetInspectionTypeSelectedDetails.bind(this));
  }
  callbackMethodForGetInspectionTypeSelectedDetails(response){
    if(response.Success)
    this.InsTypeData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/inspection/add-inspection/'+value])
  window.open(ConstantsService.URL.APP + ['/inspection/add-inspection/'+value], '_self');
  }
  
  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('InspectionTypeTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  //ws['!ref'] = ws['!ref'].replace('T','S');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "InspectionType.xlsx");

  }
  //EOC Pritesh

}
